// extracted by mini-css-extract-plugin
module.exports = {"centerImage":"shared_centerImage__2mhq8","layout":"shared_layout__2zJXU","highlightLink":"shared_highlightLink__2EH3J"};